// extracted by mini-css-extract-plugin
export default {"profile-controls":"FriendControls_profile-controls__L5Mdk","add":"FriendControls_add__Ve2le","loading":"FriendControls_loading__WQuwS"};